import React, { useEffect, createElement } from 'react';
import { LandingPage } from './components/LandingPage';
const META_PIXEL_ID = '2048577635697243';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const head = document.head || document.getElementsByTagName('head')[0];
    if (head) head.appendChild(script);
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <LandingPage data-id="element-0" />;
}